import React, { useContext } from 'react';
import {
  Button,
  Image,
  Text,
  Title3,
} from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useAcceptInvitationStyles } from '../styles';
import HeaderLogo from '../../../media/microsoft-advertising-logo-idp-header.png';

export type ActivationErrorFallbackProps = {
  // "Go back" — sign the current session out and return to the invitation choice view (the default
  // logout round-trip). Resolved by the caller.
  onBackToInvitation: () => void;
};

// Generic fallback error page shown when the invitation can't be completed in this experience and
// no dedicated error page matches (an unhandled ActivationOptions outcome, or a Validate/
// ActivationOptions API failure). Offers a single action that signs the user out and returns them
// to the invitation choice view so they can start over.
export const ActivationErrorFallback: React.FC<ActivationErrorFallbackProps> = ({ onBackToInvitation }) => {
  const i18n = useContext(I18nContext) as any;
  const classes = useAcceptInvitationStyles();

  return (
    <div className={classes.centeredPage}>
      <div
        className={classes.errorCard}
        role="region"
        aria-labelledby="activation-error-fallback-title"
        aria-describedby="activation-error-fallback-description"
      >
        <Image className={classes.brandLogo} src={HeaderLogo} alt={i18n.getString(_TL_('Microsoft Advertising'))} />

        <Title3 id="activation-error-fallback-title" className={classes.errorTitle}>
          {i18n.getString(_TL_('Something went wrong'))}
        </Title3>

        <div id="activation-error-fallback-description" className={classes.errorBody}>
          <Text block>
            {i18n.getString(_TL_('We couldn\'t process this invitation. Sign out and go back to try again.'))}
          </Text>
        </div>

        <div className={classes.errorActions}>
          <Button
            className="invitation-error-go-back"
            appearance="primary"
            onClick={onBackToInvitation}
          >
            {i18n.getString(_TL_('Go back'))}
          </Button>
        </div>
      </div>
    </div>
  );
};
